export default {
    SERVERHOLDER: 'serverHolder',
    SERVER: 'server',
    DOMAINHOLDER: 'domainHolder',
    DOMAIN: 'domain'
}